"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetSuppressEmail = SetSuppressEmail;
exports.SendOTPEmail = SendOTPEmail;
exports.SendOTPEmailC = SendOTPEmailC;
var response_1 = require("@ca/wrap-sdk/src/response");
var aws_cognito_1 = require("@ca/wrap-sdk/src/aws-cognito");
var wlf_item_1 = require("../wlf-item");
var email_1 = require("@ca/email");
var aws_ses_1 = require("@ca/wrap-sdk/src/aws-ses");
var time_1 = require("@ca/time");
var SUPPRESS_EMAIL = false;
function SetSuppressEmail(value) {
    SUPPRESS_EMAIL = value;
}
function RenderEmail(name, wlf, otp) {
    var address = (0, email_1.RenderAddress)(wlf);
    var footer = (0, email_1.RenderFooter)(wlf);
    return "\n  <html>\n    <body>\n      <p>Hello ".concat(name, "</p>\n      <p>Please use this one time password to gain access to your account:</p>\n      <div style=\"font-size: 2rem;\" align=\"center\">").concat(otp, "</div>\n      <p>If you didn\u2019t initiate this request, please ignore this email.</p>\n      <p>Stay secure!</p>\n      <p>").concat(address, "</p>\n      ").concat(footer, "\n    </body>\n  </html>\n  ");
}
function SendOTPEmail(username, otp) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, SendOTPEmailC(null, username, otp)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function SendOTPEmailC(creds, username, otp) {
    return __awaiter(this, void 0, void 0, function () {
        var a_resp, user, wlf_id, w_resp, wlf, html, wlf_name, subject, source_email, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (SUPPRESS_EMAIL) {
                        return [2 /*return*/, (0, response_1.SuccessResponse)({})];
                    }
                    return [4 /*yield*/, (0, aws_cognito_1.AdminGetUserC)(creds, username)];
                case 1:
                    a_resp = _a.sent();
                    if (a_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, a_resp];
                    }
                    user = a_resp.payload;
                    wlf_id = user.wlf_id;
                    return [4 /*yield*/, (0, wlf_item_1.GetWlfItemC)(creds, wlf_id)];
                case 2:
                    w_resp = _a.sent();
                    if (w_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, w_resp];
                    }
                    wlf = w_resp.payload;
                    html = RenderEmail(user.name, wlf, otp);
                    wlf_name = wlf.email && wlf.email.otp_email_name || wlf.name;
                    subject = "Your One-Time Password for " + wlf_name;
                    source_email = wlf.email && wlf.email.source_email || "support@cleveralpha.com";
                    return [4 /*yield*/, (0, aws_ses_1.SendEmailC)(creds, [user.email], [], [], source_email, html, subject)];
                case 3:
                    resp = _a.sent();
                    if (resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, resp];
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)({
                            to_address: [user.email],
                            message_id: resp.payload.MessageId,
                            timestamp_ms: (0, time_1.get_now_ms)(),
                        })];
            }
        });
    });
}
//# sourceMappingURL=otp-email.js.map